import "./view.scss";

document.addEventListener('DOMContentLoaded', function() {
    const clearButton = document.querySelector('.clear');
    const searchForm = document.querySelector('.search-block form');

    // Guard clause - check if required elements exist
    if (!searchForm) {
        return;
    }
    if (!clearButton) {
        return;
    }

    const searchInput = searchForm.querySelector('input[name="term"]');
    const selectElements = searchForm.querySelectorAll('select');

    if (searchInput && clearButton) {

      clearButton.addEventListener('click', function() {
        // Clear text input
        searchInput.value = '';
    
        // Reset all select dropdowns to first option
        selectElements.forEach(select => {
          select.selectedIndex = 0;
        });
        searchForm.submit();
      });
    }

    
    // Apply filters through the existing Search button, without an unexpected
    // page reload while someone is still exploring the select options.
  });
